module.exports = __webpack_public_path__ + "static/media/impulso-logo-branco.caf582d3.png";